/**
 * footer.js
 * File for website footer
 */

var $ = jQuery;

jQuery(document).ready(function($) {

    // show back to top button
    function backtoTop() {
        if ($(window).scrollTop() > 900) {
            $('.footer-back-to-top').fadeIn();
        }

        if ($(window).scrollTop() < 750) {
            $('.footer-back-to-top').fadeOut();
        }
    }   

    $(window).scroll(function() {
        backtoTop();
    }).scroll();    

});
